import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";
import { JobPoVendorGroup } from "../../types/job-po";

@Injectable({
    providedIn: "root"
})
export class JobPoReportService {
    private http = inject(HttpClient);
    private jobPoBaseUrl = inject(API_ROOT) + "api/JobPO";
    private reportBaseUrl = inject(API_ROOT) + "api/reports";

    getJobPoDetails(jobId: number): Observable<JobPoVendorGroup[]> {
        const params = new HttpParams().set("jobId", jobId.toString());

        return withSpinner(this.http).get<JobPoVendorGroup[]>(this.jobPoBaseUrl, { params });
    }

    downloadJobPoNonPricingReport(documentGuid: string): Observable<Blob> {
        const params = new HttpParams().set("documentGuid", documentGuid);

        return withSpinner(this.http).get(`${this.reportBaseUrl}/download-jobpo-nonpricing-report`, {
            params,
            responseType: "blob"
        });
    }
}
